import { RenewalVehicle } from './renewal-vehicle';
import { RenewalResident } from './renewal-resident';
import { PropertyViewCard } from './property-view-card';
export class RenewalContactInfo {
    constructor(
        public LeaseRenewalToken: string = '',
        public AccessToken: string = '',
        public ResidentKey: number = null,
        public LeaseRenewalKey: number = null,
        public FirstName: string = '',
        public MiddleName: string = '',
        public LastName: string = '',
        public HomePhone: string = '',
        public CellPhone: string = '',
        public AlternativeEmail: string = '',
        public DLNum: string = '',
        public DLState: string = '',
        public Vehicles: RenewalVehicle[] = [],
        public Residents: RenewalResident[] = [],
        public HasVehicles: boolean = null,
        public IsLocked: boolean = true,
        public YardiKey: string = null,
    ) { }
}
